import clsx from "clsx";
import { usePage } from "@tree-company/tree-query";
import { useContext, useEffect, useRef } from "react";
import { Progress } from "./progress";
import { LocaleContext } from "./localization_wrapper";
import { CollapsibleGroupProvider } from "./collapsible_group_context";

const NO_NEXT_PAGE_KEYS = new Set(["street", "next"]);

export function PageComponent({
  handleSave,
  page,
  children,
  onPreviousPage,
  className,
}) {
  const { key, title, description, htmlAttributes } = usePage(page);
  const i18n = useContext(LocaleContext);
  const elementRef = useRef(null);

  useEffect(() => {
    // If our context has defined fathom, we send fake pages with the current step of the form
    if (window.fathom) {
      const locationWithKey = new URL(window.location);
      locationWithKey.pathname += `/${key}`;
      window.fathom.trackPageview({ url: locationWithKey.toString() });
    }
  }, [key]);

  useEffect(() => {
    if (elementRef.current) {
      const { top, left } = elementRef.current.getBoundingClientRect();
      window.scrollTo({ top, left });
    }
  }, [key]);

  useEffect(() => {
    if (key !== "street" || !elementRef.current) return;

    const form = elementRef.current.querySelector("form");
    if (!form) return;

    const handleChange = (event) => {
      if (event.target.type === "radio") {
        form.requestSubmit();
      }
    };

    form.addEventListener("change", handleChange);
    return () => form.removeEventListener("change", handleChange);
  }, [key]);

  return (
    <main
      className={clsx("survey-page", className, htmlAttributes?.class)}
      ref={elementRef}
    >
      <form action="" className="survey-page__form" onSubmit={handleSave}>
        <Progress onBackButton={onPreviousPage} pageKey={key} />
        {(title || description) && (
          <div className="survey-page__intro">
            {title && <h1 className="survey-page__title">{title}</h1>}
            {description && <p className="survey-page__text">{description}</p>}
          </div>
        )}
        <CollapsibleGroupProvider>{children}</CollapsibleGroupProvider>
        {!NO_NEXT_PAGE_KEYS.has(key) && (
          <button className="survey-page__action">
            {i18n.t("general.next_page")}
          </button>
        )}
      </form>
    </main>
  );
}
